import { TemplateElement, html, defineElement, i18n } from '@webtides/element-js';

// import days from './days.mock';

export default class OpeningHours extends TemplateElement {
    constructor() {
        super({ deferRender: true, autoRender: true, shadowRender: false });
    }

    connected() {
        this.processHours();
        this.requestUpdate();
    }

    properties() {
        return {
            days: [],
        };
    }

    get hours() {
        return this.processHours();
    }

    get hasOpenHours() {
        //not data or not opened
        return this.days && this.days.some(d => d.fromOne);
    }

    processHours() {
        if (!this.hasOpenHours) {
            return [];
        }
        let currentCluster = null;
        const cluster = [];

        this.days.forEach((day, index) => {
            if (currentCluster === null) {
                currentCluster = { ...day };
                cluster.push(currentCluster);
            }

            if (index < this.days.length - 1) {
                const nextDay = this.days[index + 1];
                const ignoreDay = (key, value) => {
                    return key === 'day' ? null : value;
                };
                if (JSON.stringify(day, ignoreDay) === JSON.stringify(nextDay, ignoreDay)) {
                    // same opening hours
                    currentCluster.toDay = nextDay.day;
                } else {
                    currentCluster = null;
                }
            }
        });
        return cluster;
    }

    parseDay(day) {
        return i18n(`weekdays.${day}`);
    }

    parseTime(time) {
        const [hours, minutes] = time.split(':');
        return html`
            ${hours}:${minutes}
        `;
    }

    template() {
        return html`
            <ul class="">
                ${this.hours.map(day => {
                    return html`
                        <li class="row no-gutters bg-grey-100 odd:bg-white my-1 p-1">
                            <div class="col w-1/2 uppercase text-grey-600 font-thin">
                                ${this.parseDay(day.day)}
                                ${day.toDay
                                    ? html`
                                          <span>- ${this.parseDay(day.toDay)}</span>
                                      `
                                    : ``}
                            </div>
                            <div class="col w-1/2 lowercase font-normal">
                                ${day.fromOne
                                    ? html`
                                          <div>${this.parseTime(day.fromOne)} - ${this.parseTime(day.toOne)}</div>
                                      `
                                    : `${i18n('retailerSearch.IS_CLOSED_TEXT')}`}
                                ${day.fromTwo
                                    ? html`
                                          <div>${this.parseTime(day.fromTwo)} - ${this.parseTime(day.toTwo)}</div>
                                      `
                                    : ``}
                            </div>
                        </li>
                    `;
                })}
            </ul>
        `;
    }
}

defineElement('opening-hours', OpeningHours);
